import React, { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import { useTranslation } from "react-i18next";

const HeaderLanding = (props) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="header dashboard">
      <Container>
        <Row>
          <Col>
            <Navbar light expand="lg" className="p-0">
              <NavbarBrand to="/home" tag={RRNavLink}>
                <span>Miracle Pace</span>
              </NavbarBrand>
              <NavbarToggler onClick={toggle} />
              <Collapse isOpen={isOpen} navbar>
                <Nav navbar>
                  <NavItem>
                    <NavLink to="/home" tag={RRNavLink}>
                      {t("home.label")}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink to="/contactus" tag={RRNavLink}>
                      {t("contactUs.label")}
                    </NavLink>
                  </NavItem>
                </Nav>
              </Collapse>
            </Navbar>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeaderLanding;
